import { render, staticRenderFns } from "./Wells.vue?vue&type=template&id=4fb27552&scoped=true"
import script from "./Wells.vue?vue&type=script&lang=js"
export * from "./Wells.vue?vue&type=script&lang=js"
import style0 from "./Wells.vue?vue&type=style&index=0&id=4fb27552&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb27552",
  null
  
)

export default component.exports